import { render, staticRenderFns } from "./GeneralSetting.vue?vue&type=template&id=daffd112&"
import script from "./GeneralSetting.vue?vue&type=script&lang=ts&"
export * from "./GeneralSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralSetting.vue?vue&type=style&index=0&id=daffd112&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports